export const CURRENCY_ITEMS = [
  {
    text: 'USD',
    value: 'USD',
  },
  {
    text: 'EUR',
    value: 'EUR',
  },
  {
    text: 'RUB',
    value: 'RUB',
  },
]

export const currencySymbols = {
  USD: '$',
  EUR: '€',
  RUB: '₽',
}

export function formatMetrics(data) {
  const formatted = {}

  const percentFields = ['vtr', 'completionRate', 'fillRate']
  const currencyFields = ['dailyBudget', 'totalBudget', 'statSpend', 'cpc', 'cpm', 'cpv']

  Object.keys(data).forEach((key) => {
    if (percentFields.includes(key)) {
      formatted[key] = `${data[key]} %`
    } else if (currencyFields.includes(key)) {
      const symbol = currencySymbols[data.currency] ?? data.currency
      formatted[key] = `${data[key]} ${symbol}`.trim()
    } else {
      formatted[key] = data[key]
    }
  })

  return formatted
}
